<template>
  <div class="animated fadeIn">
    <b-card v-if="showList">
      <div slot="header">Asset Maintenance Book 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" class="mb-1">
        <b-col lg="6">
              <b-row no-gutters>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>FA Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asetid" placeholder="FA Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">FA Name &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.asdesc" placeholder="FA Name/Description"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>                      
            <b-input-group >
              <b-input-group-prepend><label>User | Location</label></b-input-group-prepend>
              <b-form-input v-model="tblData.asuser" placeholder="User"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCrewShow=true" ><i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
              <b-form-input v-model="tblData.aslocat" placeholder="Location" class="ml-2"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuAssetlocatShow=true"> <i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-col>
        <b-col lg="6">
              <b-row>
                <b-col lg="7">
                    <b-input-group >
                      <b-input-group-prepend><label>Asset Category</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.assetCatgId" :plain="true" :options="categories"></b-form-select>
                    </b-input-group>
                  </b-col>
                <b-col  lg="5">
                    <b-input-group >
                      <b-input-group-prepend><span>Model/Type</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.assetModel" placeholder="Model/Type/Series"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>     
            <b-input-group >
              <b-input-group-prepend><span class="pt-2">Maintenance Name &nbsp;</span></b-input-group-prepend>
              <b-form-input v-model="tblData.inspectName" ></b-form-input>
              <b-input-group-append>
                  <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
              </b-input-group-append>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
          <template v-slot:cell(tanggal)="data">
            <span v-if="(data.item.tanggal)">{{data.item.tanggal| moment('D-MMM-YY')}}</span>
          </template>
          <template v-slot:cell(uomValue)="data">
            <span v-if="(data.item.uomValue)">{{data.item.uomValue}} {{data.item.uomCode}} </span>
          </template>
        <template v-slot:cell(intervalCal)="data">
          {{data.item.intervalCal}} days
        </template>
        <template v-slot:cell(intervalCal)="data">
          {{data.item.intervalCal | numFormat}} DAYS <br>
          <p v-if="(data.item.intervalUom)">{{data.item.intervalUom |numFormat }} {{data.item.intervalUomCode}}</p>
        </template>
      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this ?</p>
      </b-modal>
  </div>
</template>

<style lang="scss">
    .list-of-fixedasset {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: 120px;
        }
      }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import mmasset from "../../apis/maintenasset";
toastr.init();

export default {
  components: { Loading},
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      showFilter:false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'asetid',
        sortDesc: false,
      },
      model:{asetkey:''},
      categories:[],
      tblFields:[
          {
            key: "referDoc",
            label: "Doc. No.",
            thStyle: "width:140px",
            sortable: true
          },
          {
            key: "inspectName",
            label: "Maintenance/Inspection Name",
          },
          {
            key: "catgname",
            label: "Category/Group",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "asetid",
            thStyle: "width:100px",
            label: "FA Number",
            sortable: true
          },
          {
            key: "asdesc",
            label: "FA Name/Description",
          },
          {
            key: "asmodel",
            label: "Model/Type/Series",
            sortable: true
          },
          {
            key: "asserial",
            label: "S/N",
            sortable: true
          },
          {
            key: "assetPart",
            label: "Part/Component",
            thStyle: "width:120px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Last Maintenance",
            sortable: true
          },
          {
            key: "uomValue",
            label: "OdoMeter",
            sortable: true
          },
          {
            key: "intervalCal",
            label: "Repetitif Interval",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: "width:150px",
            sortable: true
          },
        ],
      categories:[]
    };

  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    catgid() {
      return this.tblData.catgid;
    },
  },
  watch:{
    catgid: function(newval){
      const catg = this.categories.find(c => c.value == newval)
      if (catg) {
        this.tblData.category=catg.text;
      }
    }
  },
  created: async function(){
      const [a] = await Promise.all([mmasset.category()]) ;
        this.categories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
  },  
  methods: {
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.mmList) {
            this.tblData[key] = filter.mmList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.mmList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await mmasset.list(this.tblData);      
      this.isLoading=false;
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table)  this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.assetCatgId= '';
        this.tblData.assetCatgName= '';
        this.tblData.assetModel=  '';
    },
    saveFilter() {
      const keys = ['catgid', 'category', 'catgname', 'nomorpo', 'outstand', 'asetid', 'asdesc', 'asmodel','asserial', 'asuser', 'aslocat', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal'];
      let filtered = false;
      const mmList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              mmList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          mmList.page=this.tblData.page;
          mmList.limit=this.tblData.limit;
          mmList.sortBy=this.tblData.sortBy;
          mmList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.mmList=mmList;
          this.$store.commit("filter", filter);
      }
    },    

    add: function(data) {
        this.saveFilter()
          router.push({name :'fixedasset.maintassetmmfrm'});
    },
    edit: function() {
      if (this.model.asetkey) {
        this.saveFilter()
        router.push({name :'fixedasset.maintassetmmfrm', params: { asetkey: this.model.asetkey}});
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    save: function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              mmasset.save(this.frmdata);
              this.closeFrm();    
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm() {
        if (this.model.maintAsstatKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
        console.log('this.model : ',this.model);
      await mmasset.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      // if (this.model.asetkey==record.asetkey) {
      //   console.log('model row click: ', this.model);
      //   this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.expMode='acc';
            const response = await mmasset.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
